export const AUTH_TOKEN = 'auth_token';

export const SUPER_USERS = [
  'df61b8a7-e779-4078-8b68-0a88e48a428c',
  '48936ee6-ace8-488d-b7a5-b46bbdc108ad',
  '444a9d4e-05b6-4753-a4b6-d4b393303633',
  '38fcc051-bb83-46d4-99c2-610c597c49bc',
];
